<template>
    <div class="card-item" :style="cardStyle">
      <img class="card-icon" :style="cardIconStyle" :src="item.icon" alt="">
      <div class="title" :style="cardTitleStyle">{{ item.name }}</div>
      <div class="desc" :style="cardDescStyle">
        <div class="desc-item" :style="cardDescStyleItem" v-for="(i, index) in item.descList" :key="index">
          <img class="desc-item-icon" v-if="item.imgShow" :src="CancelImg" alt="">
          <span>{{ i }}</span>
        </div>
      </div>
    </div>
</template>
<script>
import Cancel from '@/assets/home/check.svg'
export default {
  props: {
    item: {
      type: Object,
      default : () => {
        return {}
      }
    },
    cardStyle: {
      type: Object,
      default : () => {
        return {}
      }
    },
    cardIconStyle: {
      type: Object,
      default : () => {
        return {}
      }
    },
    cardTitleStyle: {
      type: Object,
      default : () => {
        return {}
      }
    },
    cardDescStyle: {
      type: Object,
      default : () => {
        return {}
      }
    },
    cardDescStyleItem: {
      type: Object,
      default : () => {
        return {}
      }
    },
  },
   data() {
      return {
        CancelImg: Cancel,
      }
   },
   created(){
   },
   computed:{
   },
   methods:{
   },
}
</script>
<style lang="less" scoped>
.card-item {
  overflow: hidden;
  padding: 30px 40px 0 40px;
  width: 380px;
  height: 205px;
  background-color: #F4F5FB;
  border-radius: 6px;
  margin-bottom: 30px;
}
.card-icon {
  width: 40px;
  height: 40px;
  margin-bottom: 18px;
}
.title {
  font-weight: bold;
  font-size: 18px;
  color: #222222;
  line-height: 22px;
  text-align: center;
  margin-bottom: 12px;
}
.desc {
  font-size: 14px;
  color: #595859;
  line-height: 20px;
  text-align: left;
}
.desc-item {
  display: flex;
  margin-bottom: 12px;
}
.desc-item-icon {
  width: 16px;
  height: 16px;
  margin-right: 4px;
}
</style>
